import axiosInstance from "../../utils/axiosConfig";
import React, { useCallback, useEffect, useState } from "react";
import { noTransaction } from "../../assets/images";
import { API_URL, getAssetImage } from "../../constant";
import { useAuth } from "../../context/auth-context";
import { BsArrowLeftSquare, BsArrowRightSquare } from "react-icons/bs";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { useLocation } from "react-router-dom";
import { formatAmount } from "../../utils/FormatPerson";

const CryptoOrders = ({
  orderFilter = "all",
  setOrderModal,
  setUserId,
  setTsxnId,
  setCurrency,
  setCurrencyUSD,
  setCurrencyNGN,
  setStatus,
  setPayoutStatus,
  setNetwork,
  setDate,
  refetchCount,
  setCryptoRate,
  currencyNGNGiftcard,
  setImageURL,
  setStatusGiftcard,
  setDateGiftcard,
  setCurrencyUSDGiftcard,
  setCurrencyNGNGiftcard,
  setUserIdGiftcard,
  setGiftcardUser,
  setTxnId,
  setCardType,
  setEcode,
  setOrderGiftcardModal,
  setOrderss,
  setNewOrders,
}: any) => {
  const { isAuthenticated, query } = useAuth();
  const [payoutnew, setPayoutnew] = useState<any[]>([]);
  const [sortedData, setSortedData] = useState<any[]>([]);
  const [payoutLoader, setPayoutLoader] = useState<boolean>(false);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | "">("");
  const [sortOrderType, setSortOrderType] = useState<"asc" | "desc" | "">("");
  const [sortOrderAsset, setSortOrderAsset] = useState<"asc" | "desc" | "">("");
  const [sortOrderDate, setSortOrderDate] = useState<"asc" | "desc" | "">("");

  const [page, setPage] = useState<number>(1);

  const [currentpage, setCurrentPage] = useState<number>();

  const [paginatedData, setPaginatedData] = useState<any[]>([]);

  const [totalPages, setTotalPages] = useState<number>(1);
  const location = useLocation();

  const limit = location.pathname === "/dashboard" ? 10 : 25;

  const getTransactionsQuery = useCallback(
    (pageNum: number) => {
      const base = `${API_URL}api/transactions?page=${pageNum}&limit=${limit}`;
      if (orderFilter === "crypto") {
        return `${base}&excludeTypes=payouts,deex-fiat-deposits,gift-card-transactions`;
      }
      if (orderFilter === "giftcard") {
        return `${base}&includeTypes=gift-card-transactions`;
      }
      return `${base}&excludeTypes=payouts,deex-fiat-deposits`;
    },
    [orderFilter, limit]
  );

  const fetchAllData = useCallback(async () => {
    // The session bootstrap is async; fetching before it resolves just 401s.
    if (!isAuthenticated) return;
    setPayoutLoader(true);
    try {
      const url = getTransactionsQuery(page);
      const paginationResponse = await axiosInstance.get(url);

      const { totalPages, page: currentPage } =
        paginationResponse.data.data.meta;
      setTotalPages(totalPages);
      setCurrentPage(currentPage);

      let transactions = paginationResponse.data.data.transactions || [];
      if (orderFilter === "giftcard") {
        transactions = transactions.filter(
          (t: any) => t.transactionType === "gift-card-transactions"
        );
      }

      setPayoutnew(transactions);
      setSortedData(transactions);
      setPaginatedData(transactions);
      setNewOrders(transactions);

      setPayoutLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPayoutLoader(false);
    }
  }, [isAuthenticated, page, orderFilter, setNewOrders, getTransactionsQuery]);

  // Initial data load and when filter/page/refetch changes
  useEffect(() => {
    fetchAllData();
  }, [fetchAllData, refetchCount]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (query) {
        setPayoutLoader(true);
        axiosInstance
          .get(getTransactionsQuery(page))
          .then((r: any) => {
            setPayoutLoader(false);
            setTotalPages(r.data.data.meta.totalPages);
            setCurrentPage(r.data.data.meta.page);
            let transactions = r.data.data.transactions || [];
            if (orderFilter === "giftcard") {
              transactions = transactions.filter(
                (t: any) => t.transactionType === "gift-card-transactions"
              );
            }
            setPayoutnew(transactions);
            setSortedData(transactions);
            setPaginatedData(transactions);
            setNewOrders(transactions);
          })
          .catch((e: any) => {
            console.log(e.response.data.message);
            setPayoutLoader(false);
          });
      } else {
        fetchAllData();
      }
    }, 600);
    return () => clearTimeout(debounceTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, page, isAuthenticated, orderFilter]);

  // Client-side sorting for the current page data
  useEffect(() => {
    if (payoutnew.length === 0) return;

    let sorted = [...payoutnew];

    if (sortOrder === "asc") {
      sorted = sorted.sort((a, b) => {
        const nameA = `${a?.userDetails?.profile?.firstName} ${a?.userDetails?.profile?.lastName}`;
        const nameB = `${b?.userDetails?.profile?.firstName} ${b?.userDetails?.profile?.lastName}`;
        return nameA.localeCompare(nameB);
      });
    } else if (sortOrder === "desc") {
      sorted = sorted.sort((a, b) => {
        const nameA = `${a?.userDetails?.profile?.firstName} ${a?.userDetails?.profile?.lastName}`;
        const nameB = `${b?.userDetails?.profile?.firstName} ${b?.userDetails?.profile?.lastName}`;
        return nameB.localeCompare(nameA);
      });
    } else if (sortOrderAsset === "asc") {
      sorted = sorted.sort((a, b) => {
        const assetA =
          a.transactionType === "gift-card-transactions"
            ? a.card?.name || ""
            : a.transactionType === "payouts"
            ? a?.asset?.name || ""
            : a.transactionType === "deex-asset-swaps"
            ? a?.from?.asset || ""
            : a.currency || "";
        const assetB =
          b.transactionType === "gift-card-transactions"
            ? b.card?.name || ""
            : b.transactionType === "payouts"
            ? b?.asset?.name || ""
            : b.transactionType === "deex-asset-swaps"
            ? b?.from?.asset || ""
            : b.currency || "";
        return assetA.localeCompare(assetB);
      });
    } else if (sortOrderAsset === "desc") {
      sorted = sorted.sort((a, b) => {
        const assetA =
          a.transactionType === "gift-card-transactions"
            ? a.card?.name || ""
            : a.transactionType === "payouts"
            ? a?.asset?.name || ""
            : a.transactionType === "deex-asset-swaps"
            ? a?.from?.asset || ""
            : a.currency || "";
        const assetB =
          b.transactionType === "gift-card-transactions"
            ? b.card?.name || ""
            : b.transactionType === "payouts"
            ? b?.asset?.name || ""
            : b.transactionType === "deex-asset-swaps"
            ? b?.from?.asset || ""
            : b.currency || "";
        return assetB.localeCompare(assetA);
      });
    } else if (sortOrderType === "asc") {
      sorted = sorted.sort((a, b) => {
        const typeA = a.transactionType || "";
        const typeB = b.transactionType || "";
        return typeA.localeCompare(typeB);
      });
    } else if (sortOrderType === "desc") {
      sorted = sorted.sort((a, b) => {
        const typeA = a.transactionType || "";
        const typeB = b.transactionType || "";
        return typeB.localeCompare(typeA);
      });
    } else if (sortOrderDate === "asc") {
      sorted = sorted.sort((a, b) => {
        const dateA = new Date(a.createdAt || a.processedAt).getTime();
        const dateB = new Date(b.createdAt || b.processedAt).getTime();
        return dateA - dateB;
      });
    } else if (sortOrderDate === "desc") {
      sorted = sorted.sort((a, b) => {
        const dateA = new Date(a.createdAt || a.processedAt).getTime();
        const dateB = new Date(b.createdAt || b.processedAt).getTime();
        return dateB - dateA;
      });
    }

    setSortedData(sorted);
    setPaginatedData(sorted);
  }, [payoutnew, sortOrder, sortOrderType, sortOrderAsset, sortOrderDate]);

  return (
    <div className="w-full  h-full">
      {payoutLoader ? (
        <div className="lgss:flex gap-5 w-full h-[500px] mb-20 ">
          <div className=" relative w-full space-y-3 overflow-hidden  bg-[#5c6b73] bg-opacity-30 p-8 shadow before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r before:from-transparent before:via-white/40 hover:shadow-lg before:animate-[shimmer_1.3s_infinite]">
            <div className="grid grid-cols-5 gap-2 mt-4">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2 mt-4">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2 mt-4">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-5 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
          </div>
        </div>
      ) : sortedData.length >= 1 ? (
        <div className="bg-[#0D0D0D]  overflow-auto scrollbar-thumb-[#60B7F6] scrollbar-track-white  scrollbar-thin   lgss:flex lgss:flex-col w-full h-[512px] mb-8 ">
          <table className="w-full">
            <thead className="sticky top-0 bg-[#1C2227]">
              <tr className="h-[56px] bg-[#1C2227] flex justify-start px-8 items-center ">
                <th
                  onClick={() => {
                    if (sortOrder === "desc") {
                      setSortOrder("asc");
                    } else {
                      setSortOrder("desc");
                    }
                  }}
                  className="text-[#617889] gap-12 cursor-pointer mr-4 flex justify-start items-center text-[15px] w-2/12  whitespace-nowrap "
                >
                  Name
                  <div className="flex flex-col justify-center items-center">
                    <TiArrowSortedUp
                      className={
                        sortOrder === "asc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                    <TiArrowSortedDown
                      className={
                        sortOrder === "desc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                  </div>
                </th>
                <th
                  onClick={() => {
                    if (sortOrderAsset === "desc") {
                      setSortOrderAsset("asc");
                    } else {
                      setSortOrderAsset("desc");
                    }
                  }}
                  className="text-[#617889] gap-12 cursor-pointer flex justify-start items-center text-[15px] w-2/12  whitespace-nowrap "
                >
                  Asset
                  <div className="flex flex-col justify-center items-center">
                    <TiArrowSortedUp
                      className={
                        sortOrderAsset === "asc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                    <TiArrowSortedDown
                      className={
                        sortOrderAsset === "desc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                  </div>
                </th>
                <th
                  onClick={() => {
                    if (sortOrderType === "desc") {
                      setSortOrderType("asc");
                    } else {
                      setSortOrderType("desc");
                    }
                  }}
                  className="text-[#617889] gap-12 cursor-pointer flex justify-start items-center text-[15px] w-2/12  whitespace-nowrap "
                >
                  Type
                  <div className="flex flex-col justify-center items-center">
                    <TiArrowSortedUp
                      className={
                        sortOrderType === "asc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                    <TiArrowSortedDown
                      className={
                        sortOrderType === "desc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                  </div>
                </th>
                <th className="text-[#617889] gap-8 cursor-pointer flex justify-start items-center text-[15px] w-2/12  whitespace-nowrap ">
                  Amount
                </th>
                <th className="text-[#617889] text-[15px] mr-3 whitespace-nowrap w-2/12 text-left">
                  Trans ID
                </th>
                <th
                  onClick={() => {
                    if (sortOrderDate === "desc") {
                      setSortOrderDate("asc");
                    } else {
                      setSortOrderDate("desc");
                    }
                  }}
                  className="text-[#617889] gap-12 cursor-pointer flex justify-start items-center text-[15px] w-2/12  whitespace-nowrap "
                >
                  Date
                  <div className="flex flex-col justify-center items-center">
                    <TiArrowSortedUp
                      className={
                        sortOrderDate === "asc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                    <TiArrowSortedDown
                      className={
                        sortOrderDate === "desc"
                          ? "text-[#BDBDBE] text-[14px]"
                          : "text-[#617889] text-[12px]"
                      }
                    />
                  </div>
                </th>
                <th className="text-[#617889] text-[15px] whitespace-nowrap w-2/12 xxl:w-1/12 text-center xxl:text-left">
                  Status
                </th>
              </tr>
            </thead>
            {paginatedData.map((payout, index) => {
              const assetSymbol =
                payout.transactionType === "payouts"
                  ? payout?.asset?.name
                  : payout.transactionType === "deex-asset-swaps"
                  ? payout?.from?.asset
                  : payout.currency;
              const assetImage = getAssetImage(assetSymbol);
              return (
                <tbody
                  onClick={() => {
                    if (payout.transactionType !== "gift-card-transactions") {
                      setOrderModal((prev: any) => !prev);
                      setUserId(payout.userId);
                      setTsxnId(payout._id);
                      setOrderss(payout);
                      if (
                        payout.transactionType !== "deex-crypto-withdrawals"
                      ) {
                        setCurrencyUSD(payout.amount);
                        if (payout?.currency === "USDT" || "usdt") {
                          setCryptoRate(payout?.rates[0]?.rate);
                        } else if (payout?.currency === "BTC" || "btc") {
                          setCryptoRate(payout?.rates[1]?.rate);
                        } else setCryptoRate(0);
                      }
                      setCurrency(payout.currency);

                      if (
                        payout.transactionType === "deex-crypto-withdrawals"
                      ) {
                      } else {
                        setCurrencyUSD(formatAmount(payout.usdtAmount));
                      }
                      if (
                        payout.transactionType === "deex-crypto-withdrawals"
                      ) {
                        setCurrencyNGN(0);
                      } else {
                        if (payout.currency === "USDT" || "usdt") {
                          setCurrencyNGN(
                            formatAmount(
                              payout?.usdtAmount * payout?.rates[0]?.rate
                            )
                          );
                        } else if (payout.currency === "BTC" || "btc") {
                          setCurrencyNGN(
                            formatAmount(
                              payout?.usdtAmount * payout?.rates[1]?.rate
                            )
                          );
                        }
                      }

                      if (payout.payout) {
                        setPayoutStatus(true);
                      } else {
                        setPayoutStatus(false);
                        if (payout.processingState) {
                          setStatus(payout.processingState);
                        }
                      }
                      setNetwork(payout.network);
                      setDate(() => {
                        const dateString =
                          payout.createdAt || payout.processedAt;
                        const date = new Date(dateString);

                        const day = date.getDate();
                        const ordinalSuffix = (day: number) => {
                          switch (day) {
                            case 1:
                            case 21:
                            case 31:
                              return "st";
                            case 2:
                            case 22:
                              return "nd";
                            case 3:
                            case 23:
                              return "rd";
                            default:
                              return "th";
                          }
                        };

                        const formattedDate = `${date.toLocaleString(
                          "default",
                          {
                            month: "short",
                          }
                        )} ${day}${ordinalSuffix(
                          day
                        )}, ${date.getFullYear()} | ${date.toLocaleString(
                          "default",
                          {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          }
                        )}`;

                        return formattedDate;
                      });
                    } else {
                      setCardType(payout);
                      setCurrencyNGNGiftcard(() => {
                        let totalAmount = 0;
                        if (payout.country) {
                          if (
                            payout.card &&
                            payout.tradeValue &&
                            Array.isArray(payout.tradeValue)
                          ) {
                            payout.tradeValue.forEach(
                              (trade: { range: any; amount: number }) => {
                                const range = trade.range;
                                let rate = 0;

                                // Find the rate based on the new structure
                                const rateInfo = payout.card.rates.find(
                                  (r: {
                                    range: {
                                      min: number;
                                      max: number;
                                    };
                                    type: any;
                                  }) =>
                                    r.range.min <= range.min &&
                                    r.range.max >= range.max &&
                                    r.type === payout.type
                                );

                                if (rateInfo) {
                                  rate = rateInfo.rate;
                                  const amount = trade.amount * rate;
                                  totalAmount += amount;
                                }
                              }
                            );
                          }
                        } else {
                          if (
                            payout.card &&
                            payout.tradeValue &&
                            Array.isArray(payout.tradeValue)
                          ) {
                            payout.tradeValue.forEach(
                              (trade: { range: any; amount: number }) => {
                                const range = trade.range;
                                let rate = 0;

                                switch (payout.type) {
                                  case "physicalActivationReceipt":
                                    rate =
                                      payout.card.country.rates.physicalActivationReceipt.find(
                                        (r: {
                                          range: {
                                            min: number;
                                            max: number;
                                          };
                                        }) =>
                                          r.range.min <= range.min &&
                                          r.range.max >= range.max
                                      )?.rate;
                                    break;
                                  case "physicalCashReceipt":
                                    rate =
                                      payout.card.country.rates.physicalCashReceipt.find(
                                        (r: {
                                          range: {
                                            min: number;
                                            max: number;
                                          };
                                        }) =>
                                          r.range.min <= range.min &&
                                          r.range.max >= range.max
                                      )?.rate;
                                    break;
                                  case "physicalCreditCardReceipt":
                                    rate =
                                      payout.card.country.rates.physicalCreditCardReceipt.find(
                                        (r: {
                                          range: {
                                            min: number;
                                            max: number;
                                          };
                                        }) =>
                                          r.range.min <= range.min &&
                                          r.range.max >= range.max
                                      )?.rate;
                                    break;
                                  case "physicalDebitCardReceipt":
                                    rate =
                                      payout.card.country.rates.physicalDebitCardReceipt.find(
                                        (r: {
                                          range: {
                                            min: number;
                                            max: number;
                                          };
                                        }) =>
                                          r.range.min <= range.min &&
                                          r.range.max >= range.max
                                      )?.rate;
                                    break;
                                  case "physicalNoReceipt":
                                    rate =
                                      payout.card.country.rates.physicalNoreceipt.find(
                                        (r: {
                                          range: {
                                            min: number;
                                            max: number;
                                          };
                                        }) =>
                                          r.range.min <= range.min &&
                                          r.range.max >= range.max
                                      )?.rate;
                                    break;
                                  case "ecode":
                                    rate = payout.card.country.rates.ecode.find(
                                      (r: {
                                        range: {
                                          min: number;
                                          max: number;
                                        };
                                      }) =>
                                        r.range.min <= range.min &&
                                        r.range.max >= range.max
                                    )?.rate;
                                    break;
                                  default:
                                    break;
                                }

                                if (rate) {
                                  const amount = trade.amount * rate;
                                  totalAmount += amount;
                                }
                              }
                            );
                          }
                        }
                        return totalAmount;
                      });

                      setCurrencyUSDGiftcard(
                        payout.tradeValue
                          .reduce(
                            (total: any, item: { amount: any }) =>
                              total + item.amount,
                            0
                          )
                          .toLocaleString("en-US")
                      );
                      setStatusGiftcard(payout.status);
                      setTxnId(payout._id);
                      setUserIdGiftcard(payout.userId);
                      setGiftcardUser(payout.user ?? null);
                      setImageURL(payout.images);
                      setDateGiftcard(() => {
                        const dateString =
                          payout.createdAt || payout.processedAt;
                        const date = new Date(dateString);

                        const day = date.getDate();
                        const ordinalSuffix = (day: number) => {
                          switch (day) {
                            case 1:
                            case 21:
                            case 31:
                              return "st";
                            case 2:
                            case 22:
                              return "nd";
                            case 3:
                            case 23:
                              return "rd";
                            default:
                              return "th";
                          }
                        };

                        const formattedDate = `${date.toLocaleString(
                          "default",
                          {
                            month: "short",
                          }
                        )} ${day}${ordinalSuffix(
                          day
                        )}, ${date.getFullYear()} | ${date.toLocaleString(
                          "default",
                          {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          }
                        )}`;

                        return formattedDate;
                      });
                      if (payout.code) {
                        setEcode(payout.code);
                      }
                      setOrderGiftcardModal((prev: any) => !prev);
                    }
                  }}
                  key={index}
                  className="w-full cursor-pointer"
                >
                  <tr className="h-[56px] w-full flex justify-start px-8   items-center">
                    <td className="text-white text-[14px] w-2/12 capitalize whitespace-nowrap mr-4 text-left overflow-hidden">
                      {payout.userDetails.profile.firstName}{" "}
                      {payout.userDetails.profile.lastName}
                    </td>
                    <td className="text-white text-[14px] flex items-center gap-2 w-2/12 uppercase whitespace-nowrap text-left overflow-hidden">
                      {payout.transactionType !== "gift-card-transactions" &&
                        assetImage && (
                          <img src={assetImage} alt="" className="w-4 h-4" />
                        )}
                      {payout.transactionType === "gift-card-transactions"
                        ? payout.card?.name
                        : assetSymbol}
                    </td>
                    <td className="text-white text-[14px] w-2/12 whitespace-nowrap text-left mr-2 overflow-hidden">
                      {payout.transactionType === "deex-crypto-withdrawals" &&
                      payout.utility
                        ? payout?.utility?.type
                        : payout.transactionType?.toUpperCase()}
                    </td>
                    <td className="text-white text-[14px] w-2/12 whitespace-nowrap text-left overflow-hidden">
                      {`${
                        payout?.transactionType === "gift-card-transactions" ||
                        payout?.transaction?.type === "GIFT-CARD"
                          ? ` $${formatAmount(
                              Array.isArray(payout?.tradeValue)
                                ? payout.tradeValue.reduce(
                                    (total: any, item: { amount: any }) =>
                                      total + (Number(item?.amount) || 0),
                                    0
                                  )
                                : payout?.usdtAmount ?? payout?.amount ?? 0
                            )}`
                          : payout.transactionType === "deex-crypto-withdrawals"
                          ? ` ${formatAmount(payout.amount)} ${
                              payout?.currency
                            }`
                          : payout.transactionType === "payouts"
                          ? ` $${formatAmount(payout?.asset?.amountInUSD)}`
                          : payout.transactionType === "deex-asset-swaps"
                          ? ` ${formatAmount(payout?.from?.amount)}`
                          : payout.transactionType === "deex-deposits"
                          ? ` ${formatAmount(
                              payout?.amount
                            )} ${payout?.currency?.toUpperCase()}`
                          : ` $${formatAmount(payout?.usdtAmount)}`
                      }`}
                      <h4 className="text-[12px] font-bold">
                        {payout?.transactionType === "deex-asset-swaps"
                          ? ` ${payout?.from?.asset} -> ${payout?.to?.asset}`
                          : ""}
                      </h4>
                    </td>
                    <td className="text-white text-[14px] mr-4 w-2/12 whitespace-nowrap text-left overflow-hidden">
                      {payout._id}
                    </td>

                    <td className="text-white text-[14px] w-2/12  whitespace-nowrap text-left overflow-hidden">
                      {(() => {
                        const dateString =
                          payout.createdAt || payout.processedAt;
                        const date = new Date(dateString);

                        const day = date.getDate();
                        const ordinalSuffix = (day: number) => {
                          switch (day) {
                            case 1:
                            case 21:
                            case 31:
                              return "st";
                            case 2:
                            case 22:
                              return "nd";
                            case 3:
                            case 23:
                              return "rd";
                            default:
                              return "th";
                          }
                        };

                        const formattedDate = `${date.toLocaleString(
                          "default",
                          {
                            month: "short",
                          }
                        )} ${day}${ordinalSuffix(
                          day
                        )}, ${date.getFullYear()}, ${date.toLocaleString(
                          "default",
                          {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          }
                        )}`;

                        return formattedDate;
                      })()}
                    </td>
                    {payout.transactionType === "crypto-deposit" ||
                    payout.transactionType === "deex-deposits" ||
                    (payout.transactionType === "deex-crypto-withdrawals" &&
                      !payout.status) ? (
                      <td className="text-white text-[15px] w-2/12 xxl:w-1/12 whitespace-nowrap flex justify-end xxl:justify-start  overflow-hidden">
                        <h4 className="text-[#03C668] flex justify-center items-center w-4/5 bg-[#013019] tracking-wider h-[26px] rounded-full text-[9px] font-bold">
                          COMPLETED
                        </h4>
                      </td>
                    ) : (
                      <td className="text-white text-[15px] w-2/12 xxl:w-1/12 whitespace-nowrap flex justify-end xxl:justify-start  overflow-hidden">
                        <h4
                          className={
                            payout?.status?.toUpperCase() === "PENDING"
                              ? "text-[#CB9200] flex justify-center items-center w-4/5 bg-[#181818] tracking-wider h-[26px] rounded-full text-[9px] font-bold"
                              : payout?.status?.toUpperCase() === "FAILED"
                              ? "text-red-500 flex justify-center items-center w-4/5 bg-[#181818] tracking-wider h-[26px] rounded-full text-[9px] font-bold"
                              : payout?.status?.toUpperCase() === "COMPLETED" ||
                                payout?.status?.toUpperCase() === "SUCCESSFUL"
                              ? "text-[#03C668] flex justify-center items-center w-4/5 bg-[#0E2B1F] tracking-wider h-[26px] rounded-full text-[9px] font-bold"
                              : ""
                          }
                        >
                          {payout?.status}
                        </h4>
                      </td>
                    )}
                  </tr>
                  <tr className="w-full">
                    <td className="mt-1 w-full h-[1px] bg-[#13181B]" />
                  </tr>
                </tbody>
              );
            })}
          </table>
        </div>
      ) : (
        <div className="flex flex-col justify-center mt-16 mb-60 w-full lgss:mt-24 items-center">
          <img src={noTransaction} alt="" />
          <h4 className="font-bold text-[#869AA9] pt-2 text-[14px]">
            No recent order
          </h4>
          <p className=" text-[#869AA9] pt-2 text-[12px]">
            All your orders will show up here
          </p>
        </div>
      )}

      {paginatedData.length >= 1 && location.pathname !== "/dashboard" ? (
        <div className="flex gap-4 pb-10 justify-end items-center">
          <h4 className="font-bold font-sora text-[14px] text-white">
            Page {currentpage} of {totalPages}
          </h4>
          <button className="flex justify-center items-center">
            <BsArrowLeftSquare
              onClick={() => {
                if (page > 1) {
                  setPage((prev) => prev - 1);
                }
              }}
              className="text-3xl cursor-pointer text-[#C6D0D7] font-bold"
            />
          </button>

          <button>
            <BsArrowRightSquare
              onClick={() => {
                if (page < totalPages) {
                  setPage((prev) => prev + 1);
                }
              }}
              className="text-3xl cursor-pointer text-[#C6D0D7]"
            />
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default CryptoOrders;
